import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useWillUnmount } from 'rooks';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import {
  MediumGreenPanel,
  TitleText,
  ContinueButton,
  HeaderText,
} from './StyledComponents';
import { DescriptionText } from './FormattedText';
import AnimatedBurst from './AnimatedBurst';

export const SuccessPanel = ({ onConfirm, children, actionScope }) => {
  const { playTap, globalSfx } = useWorkshopSfx();

  useEffect(() => {
    globalSfx.levelMastery45();
  }, []);

  const clickedRef = useRef(false);
  const timeout = useRef(null);

  const onConfirmPress = (e) => {
    if (clickedRef.current) return;
    clickedRef.current = true;
    playTap(true);

    timeout.current = setTimeout(() => onConfirm(e), 150);
  };

  useWillUnmount(() => {
    clearTimeout(timeout.current);
  });

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-panel-title"
      data-dd-action-name={actionScope}
    >
      <AnimatedBurst />
      <MediumGreenPanel />
      <TitleText id="success-panel-title">SUCCESS</TitleText>
      {children}
      <ContinueButton
        onClick={onConfirmPress}
        data-dd-action-name={`${actionScope}:continue`}
      />
    </div>
  );
};

SuccessPanel.propTypes = {
  children: PropTypes.any,
  onConfirm: PropTypes.func.isRequired,
  actionScope: PropTypes.string,
};

SuccessPanel.defaultProps = {
  children: null,
  actionScope: 'success-panel',
};

export default SuccessPanel;

export const BaseSuccessModal = ({ onConfirm, headerText, descriptionText, children, actionScope }) => (
  <SuccessPanel onConfirm={onConfirm} actionScope={actionScope}>
    <StyledContainer>
      <HeaderText>{headerText}</HeaderText>
      <DescriptionText>{descriptionText}</DescriptionText>
    </StyledContainer>
    {children}
  </SuccessPanel>
);

BaseSuccessModal.propTypes = {
  children: PropTypes.any,
  descriptionText: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  actionScope: PropTypes.string,
};

BaseSuccessModal.defaultProps = {
  children: null,
  actionScope: 'success-panel',
};

const StyledContainer = styled.div`
  position: absolute;
  top: 177px;
  left: 480;
  height: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
